import type { ComponentProps } from "react"

import { NotebookPageHeader } from "./NotebookPageHeader"

/**
 * Names the notebook page: in the app's top bar when the builder has one. An
 * isolated preview has no top bar, so it gets a generic h1 of its own; the
 * document's title stays its own heading below it.
 */
export function NotebookReportsTitle({
  inTopBar,
  ...header
}: ComponentProps<typeof NotebookPageHeader> & { inTopBar: boolean }) {
  return inTopBar ? (
    <NotebookPageHeader {...header} />
  ) : (
    <h1 className="sr-only">Notebook preview</h1>
  )
}
